import { File02Icon, Image02Icon, Book02Icon, SourceCodeIcon, Analytics01Icon, Quiz04Icon, Image01Icon, Pdf01Icon } from 'hugeicons-react';
import { ResourceType } from '../types/resource';
import { AttachmentType } from '../types/message';

export const getResourceIcon = (type: ResourceType) => {
    switch (type) {
      case 'pdf':
        return <File02Icon size={18} />;
      case 'doc':
        return <File02Icon size={18} />;
      case 'image':
        return <Image02Icon />;
      case 'essay':
        return <Book02Icon size={18} />;
      case 'code':
        return <SourceCodeIcon />;
      case 'visualization':
        return <Analytics01Icon />;
      case 'quiz':
        return <Quiz04Icon />;
      default:
        return <Book02Icon />;
    }
};

export const getFileAttachmentIcon = (type: AttachmentType) => {
  switch (type) {
      case 'image/png':
      case 'image/jpeg':
      case 'image/jpg':
          return <Image01Icon />;
      case 'code':
          return <SourceCodeIcon />;  
      case 'pdf':
          return <Pdf01Icon />;
      case 'doc':
          return <File02Icon />;
      default:
          return <File02Icon />;
  }
}